export const RESOURCES = '/resources';
export const RESOURCES_MANAGED = '/resources/managed';
export const RESOURCES_STATS = '/resources/stats';
export const RESOURCES_FAVORITES_TRAY = '/resources/favorites-tray';
